import React from "react";

export default function Footer(){
  return (
    <footer className="py-8 bg-white">
      <div className="max-w-6xl mx-auto px-6 flex justify-between items-center">
        <div className="text-[color:var(--grey-700)]">©Copyright 2025</div>
        <div className="text-[color:var(--grey-700)]">All rights reserved.</div>
      </div>
    </footer>
  );
}
